import styles from "../../style.module.scss";
import useStore from "../../store/store";
import formatDate from "../../utils/format-date";
import formatHours from "../../utils/format-hours";
import {useState} from "react";
import {host} from "../../const/const";

const Submit = ({countDays, rate, rateSum, sale}) => {
    const userName = useStore((state) => state.userName)
    const setUserNameError = useStore((state) => state.setUserNameError)
    const userTel = useStore((state) => state.userTel)
    const setUserTelError = useStore((state) => state.setUserTelError)
    const userComment = useStore((state) => state.userComment)
    const carId = useStore((state) => state.carId)
    const startDate = useStore((state) => state.startDate)
    const startHours = useStore((state) => state.startHours)
    const finishDate = useStore((state) => state.finishDate)
    const finishHours = useStore((state) => state.finishHours)
    const currentInsurance = useStore((state) => state.currentInsurance)
    const carDeliveryLocation = useStore((state) => state.carDeliveryLocation)
    const carReturnLocation = useStore((state) => state.carReturnLocation)
    const carServices = useStore((state) => state.carServices)
    const promoCode = useStore((state) => state.promoCode)
    const isApplyPromoCode = useStore((state) => state.isApplyPromoCode)
    const promoCodeSale = useStore((state) => state.promoCodeSale)
    const bonusPay = useStore((state) => state.bonusPay)
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    const focusElement = (id) => {
        const inputElement = document.getElementById(id);

        if (inputElement) {
            inputElement.focus();
            inputElement.scrollIntoView({
                behavior: 'smooth',
                block: 'center'
            });
        }
    }
    const disabled = () => {
        let status = true;
        let message = '';
        if (carId && carId > 0 && !!rate && !!rate.id) {
            if (!!userName && !!userName.length) {
                if (!!userTel && userTel.replaceAll(' ', '').length >= 12) {
                    if (!!startDate && !!startHours && !!finishDate && !!finishHours && !!countDays) {
                        status = false;
                    } else {
                        focusElement('userDateStart');
                        message = 'Выберите период аренды';
                    }
                } else {
                    focusElement('userTel')
                    setUserTelError('Заполните поле Телефон')
                    message = 'Заполните поле Телефон';
                }
            } else {
                focusElement('userName')
                setUserNameError('Заполните поле Фио');
                message = 'Заполните поле Фио';
            }
        } else {
            message = 'Обновите страницу и поробуйте снова';
        }

        return [status, message];
    }
    const handleSubmit = async () => {
        setLoading(true)
        if (disabled()[0]){
            setError(disabled()[1])
            setLoading(false)
        } else {
            const data = {
                action: 'send_lead',
                fio: userName,
                tel: userTel,
                comment: userComment,
                car: carId,
                start: `${formatDate(startDate)} ${formatHours(startHours)}`,
                finish: `${formatDate(finishDate)} ${formatHours(finishHours)}`,
                days: countDays,
                rateSum: rateSum,
                rate: rate.id,
                sale: sale[0],
                saleType: sale[1],
                insurance: currentInsurance,
                deliveryLocation: carDeliveryLocation,
                returnLocation: carReturnLocation,
                service: carServices?.map((item) => item.serviceId) || null,
                promoCode: isApplyPromoCode && !!promoCodeSale ? promoCode : null,
                bonusPay: bonusPay,
            }
            try {
                const response = await fetch(host, {
                    method: "POST",
                    body: new URLSearchParams(data),
                });
                if (!response.ok) {
                    throw new Error(`Response status: ${response.status}`);
                }
                const json = await response.json();
                window.location.href = '/thank/?p=' + json?.target_name;
            } catch (error) {
                console.error(error.message);
            } finally {
                setLoading(false)
            }
        }
    }
    if (loading) {
        return (<div className={styles.loading}>Отправка данных...</div>)
    }
    return (
        <>
            <button type='button' className={styles.button} onClick={() => handleSubmit()}>Оставить
                заявку на
                аренду
            </button>
            {
                !!error && (<div className={styles.error}>{error}</div>)
            }
        </>
    );
};

export default Submit;